const cn = {
	language: {
		cn: 'CN',
		en: 'EN',
	},
	index: {
		about: {
			title: '关于我们',
			txt: '宝瑞源生物技术（北京）有限公司为美国Cordx Union集团旗下子公司。Cordx Union（简称CU）成立于2006年，总部位于美国亚特兰大都市区，是综合研发、生产、营销、服务为一体的国际化集团公司。设有Accu News准信、Coretests库尔科技、Abiores佳宝瑞源等品牌系，共21家子公司。',
		},
		guimo: {
			title: '公司规模',
			txt: '宝瑞源生物技术（北京）有限公司为北京市高新技术企业，地址位于北京房山区窦店宝瑞源工业园，专业从事体外诊断试剂的研发、生产、销售和技术服务。生产基地占地60亩，建筑面积3万余平方米，设有独立研发中心和质检中心，厂区建设有十万级和万级(局部百级)标准的净化车间，具有全套分子诊断试剂生产线及相应配套设施。'
		},
		box: {
			title: '一站式动物检测试剂平台'
		},
		product: {
			title: '产品类型'
		},
		xiaoshou: {
			title: '销售网络',
			txt: '宝瑞源产品国内销售网络遍布华东、华北、华南等各片区，销售产品包括大动物检测、小动物检测、非洲猪瘟、牛羊疾病等各种传染病检测，覆盖范围包括各类动物医院、养殖厂、检疫防疫机构等。2021年加大海外市场的开拓工作，在全球海外市场开始建立站点。',
			area: [
				{
					name: '华东地区',
					title1: '浙江省',
					title2: '江苏省',
					title3: '上海市',
					title4: '江西省',
				},{
					name: '华北地区',
					title1: '北京市',
					title2: '天津市',
					title3: '河北省',
					title4: '山东省',
				},{
					name: '华南地区',
					title1: '广东省',
					title2: '广西壮族自治区',
					title3: '海南省',
				}
			]
		},
		rongyu: {
			title: '荣誉资质'
		},
	},
	//产品中心
	product: {
		title: '产品类型',
		more: '了解更多 >>',
		no: '暂无产品...',
	},
	//公司动态
	introduce: {
		gsdt: '公司动态',
		jqzhyg: '近期展会预告',
		wqzhhg: '往期展会回顾',
		more: '了解更多 >>',
		zhhg: '展会回顾',
	},
	//行业新闻
	news: {
		title: '行业新闻'
	},
	//法规文件
	laws: {
		title: '法规文件'
	},
	//联系我们
	contact: {
		lxfs: '联系方式',
		mapAddress: '地址',
		mapAddressText: '北京市房山区窦店镇中心路8号',
		mapPhone: '电话',
		mapPhoneNum: '010-69390623 18601366088',
		mapGsmc: '宝瑞源生物技术（北京）有限公司',
		successText: '提交成功',
		lxwm: '门店信息',
		xszx: '意向留言',
		name: '如何称呼您......',
		nameText: '请输入您的姓名',
		phone: '您的电话号码......',
		phoneText: '请输入您的电话号码',
		email: '您的邮箱......',
		emailText: '请输入您的邮箱地址',
		yjyjy: '您还想了解什么......',
		yjyjyText: '请输入您想了解的内容',
		youxiang: '邮箱',
		address: '中国  北京  房山区  窦店镇  中心路8号',
		loading: '提交中......',
		submit: '提交',
	},
	//版权信息
	footer: {
		link: '友情链接',
		cpdw: '出品单位',
		sccj: '生产厂家',
		address: '地址',
		lxfs: '联系方式',
		zipcode: '邮编',
	},
	//搜索
	search: {
		title: '猫/犬/抗原/抗体',
		all: '查看全部搜索结果',
	}
};

export default cn